import { UsersApi, User, UserPreferencesCountryEnum } from '@/api';
import { UserInput } from '../models/user-input';

export abstract class NewUserService {
	protected user: UserInput = {
		email: '',
		firstName: '',
		lastName: null,
		phone: null,
		preferences: { country: UserPreferencesCountryEnum.Nz },
	};

	public get userForm(): UserInput {
		return this.user;
	}

	constructor(protected usersApi = new UsersApi()) {}

	public abstract updateUserValues(values: UserInput): void;

	public abstract save(): Promise<User | { error: string }>;

	public abstract cancel(): void;

	protected userInputValid(userInput: UserInput): userInput is User {
		return !!userInput.email && !!userInput.firstName;
	}
}
